import React, { useContext } from 'react';
import styled from 'styled-components';
import { gray100, gray300, gray600, vieurekaBlue } from 'constants/colors';
import AccountMenu from './AccountMenu';
import InvisibleBackdrop from 'components/InvisibleBackdrop';
import account from 'assets/images/ic_account.svg';
import { UserAuthContext } from 'context/UserAuthContext';
import { useHeader } from './hooks';

const Header: React.FC = () => {
  const { isVisibleAccountMenu, onToggleAccountMenu } = useHeader();
  const userAuthContext = useContext(UserAuthContext);
  const pageTitle = userAuthContext?.company_id;

  const isInvisibleAccountEmail: boolean =
    userAuthContext?.company_id !== undefined
      ? userAuthContext?.company_id.includes('tokuteinocompanyid')
      : false;

  return (
    <>
      <HeaderContainer>
        <PageTitle>{pageTitle}</PageTitle>
        <AccountEmail $isInvisible={isInvisibleAccountEmail}>
          {userAuthContext?.email}
        </AccountEmail>
        <UserIcon onClick={onToggleAccountMenu} />
        <AccountMenu isVisible={isVisibleAccountMenu} />
      </HeaderContainer>
      <InvisibleBackdrop
        hidden={!isVisibleAccountMenu}
        $zIndex={9}
        onClick={onToggleAccountMenu}
      />
    </>
  );
};

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 51px;
  background-color: ${gray100};
  border: 1px solid ${gray300};
`;

const UserIcon = styled.button`
  z-index: 10;
  width: 50px;
  height: 100%;
  background-color: transparent;
  background-image: url(${account});
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 24px;
  border: 0;
  border-left: 1px solid ${gray300};
`;

type PropsType = {
  $isInvisible: boolean;
};

const AccountEmail = styled.p<PropsType>`
  ${({ $isInvisible }) => $isInvisible && `display: none;`}
  margin: 16px 10px 0 auto;
  color: ${gray600};
  font-size: 0.8rem;
  text-align: right;
`;

const PageTitle = styled.p`
 margin: 10px auto 0 70px;
 color: ${vieurekaBlue};
 font-size: 1.5rem;
`;

export default Header;
